// src/ui/shell/SkipLink.tsx (T1): "Skip to content", the first focusable element of every shell. It moves focus
// to the page's <main id="main"> without changing the URL.
export function SkipLink() {
  return (
    <a
      class="hb-skip"
      href="#main"
      onClick={(e) => {
        const main = document.getElementById("main");
        if (!main) return;
        e.preventDefault();
        main.focus();
      }}
    >
      Skip to content
    </a>
  );
}
